import { useTranslation } from 'react-i18next'

const OffersNoAccount = () => {
  const { t } = useTranslation('offersManagement', { keyPrefix: 'offersList' })

  return (
    <div className='flex flex-col items-center justify-center py-6 rounded bg-paper-muted'>
      <div className='text-main-muted text-lg font-semibold'>
        {t('noAccount')}
      </div>
      <div className='mt-3 text-main-muted text-sm'>
        {t('noAccountSuggestion')}
      </div>
    </div>
  )
}

export default OffersNoAccount
